module.exports = __webpack_public_path__ + "assets1779866876160/img/error-401.98bba5b1.svg";